<router-outlet></router-outlet>
<div
  class="vw-100 vh-100 d-flex flex-justify-content-center flex-align-items-center"
  *ngIf="!isInit"
>
  <sc-loader [isLoading]="true" [size]="8"> </sc-loader>
</div>
